import { createFileRoute, redirect } from '@tanstack/react-router';

// The sidebar "Schedule" tab navigates to /dashboard/calendar, but typing
// /dashboard/schedule into the address bar (or following an older bookmark
// or screenshot URL) used to land on the FE 404. Mirror the crew-members
// pattern: keep this path alive as a redirect so deep links keep working.
export const Route = createFileRoute('/_dashboard/dashboard/schedule')({
  beforeLoad: () => {
    // `replace: true` swaps the deprecated `/dashboard/schedule` entry in
    // history with `/dashboard/calendar` so the operator's Back button
    // doesn't bounce them straight back into the redirect.
    throw redirect({
      to: '/dashboard/calendar',
      search: {
        view: 'week',
        date: undefined,
        tasks: true,
        bookingId: undefined,
      },
      replace: true,
    });
  },
  component: () => null,
});
